import { ASSETS } from "@/data/site";
import HeroQuote from "./HeroQuote";

const Hero = () => {
  return (
    <section
      id="home"
      className="relative bg-[#0a1830] overflow-hidden grain"
    >
      {/* IMAGE — fills from the very top of the viewport; Nav sits transparently over the sky */}
      <div className="relative w-full aspect-[3/2] lg:aspect-[16/9] lg:max-h-[78vh] bg-[#0a1830]">
        <img
          src={ASSETS.hero}
          alt="Acropolis of Athens at sunset"
          className="absolute inset-0 w-full h-full object-cover object-[center_60%]"
          loading="eager"
        />
        <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-[#0a1830] via-[#0a1830]/40 to-transparent" />
      </div>

      {/* TEXT + QUOTE WIDGET */}
      <div className="relative px-5 lg:px-10 pt-8 lg:pt-10 pb-12 lg:pb-16 bg-[#0a1830]">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-[1.1fr_1fr] gap-8 lg:gap-12 items-start">
          {/* LEFT: tagline + original description */}
          <div className="text-center lg:text-left lg:pt-6">
            <p
              data-testid="hero-tagline"
              className="font-display italic text-gold text-2xl lg:text-4xl leading-tight tracking-tight"
            >
              “Athens Transfers, Elevated.”
            </p>
            <p className="mt-4 text-sm lg:text-base text-foreground/85 leading-relaxed max-w-xl mx-auto lg:mx-0">
              Private transfers from Athens International Airport, ports, and
              throughout Greece.
            </p>
          </div>

          {/* RIGHT: instant price quote widget — airport & port transfers, any direction */}
          <div className="lg:-mt-32 z-10">
            <HeroQuote />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
